var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartItemAddOnPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3766_23152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4995 16.2603H18.1034V7.86409C18.0887 7.63009 17.9855 7.41045 17.8146 7.24991C17.6437 7.08937 17.4181 7 17.1836 7C16.9491 7 16.7235 7.08937 16.5526 7.24991C16.3817 7.41045 16.2785 7.63009 16.2639 7.86409V16.2603H7.86409C7.63009 16.2749 7.41045 16.3782 7.24991 16.549C7.08937 16.7199 7 16.9456 7 17.18C7 17.4145 7.08937 17.6401 7.24991 17.811C7.41045 17.9819 7.63009 18.0852 7.86409 18.0998H16.2603V26.4995C16.2749 26.7335 16.3782 26.9532 16.549 27.1137C16.7199 27.2743 16.9456 27.3636 17.18 27.3636C17.4145 27.3636 17.6401 27.2743 17.811 27.1137C17.9819 26.9532 18.0852 26.7335 18.0998 26.4995V18.1034H26.4995C26.7335 18.0887 26.9532 17.9855 27.1137 17.8146C27.2743 17.6437 27.3636 17.4181 27.3636 17.1836C27.3636 16.9491 27.2743 16.7235 27.1137 16.5526C26.9532 16.3817 26.7335 16.2785 26.4995 16.2639",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7273 30.5494C24.3588 30.5494 30.5455 24.3628 30.5455 16.7312C30.5455 9.09961 24.3588 2.913 16.7273 2.913C9.0957 2.913 2.90909 9.09961 2.90909 16.7312C2.90909 24.3628 9.0957 30.5494 16.7273 30.5494ZM16.7273 33.4585C25.9655 33.4585 33.4545 25.9694 33.4545 16.7312C33.4545 7.49296 25.9655 0.00390625 16.7273 0.00390625C7.48905 0.00390625 0 7.49296 0 16.7312C0 25.9694 7.48905 33.4585 16.7273 33.4585Z",
    fill: "#DCDCDC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3766_23152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartItemAddOnPlus);
export default __webpack_public_path__ + "static/media/cartItemAddOnPlus.5f701e985082d6e78c82df79eacebb0a.svg";
export { ForwardRef as ReactComponent };